import { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useCarriers } from "../../../hooks/TICKET/useCarriers";

const EMPTY_FORM = { carrier_id: "", tracking_number: "", price: "" };

const TransportModal = ({ show, onHide, onSubmit, isPending, initialData }) => {
  const [form, setForm] = useState(EMPTY_FORM);

  const { data: carriersData, isLoading: carriersLoading } = useCarriers();
  const carriers = carriersData?.data ?? [];
  useEffect(() => {
    if (!show) return;
    if (initialData) {
      setForm({
        carrier_id:      initialData.carrier?.id ?? initialData.carrier_id ?? "",
        tracking_number: initialData.tracking_number ?? "",
        price:           initialData.price ?? "",
      });
    } else {
      setForm(EMPTY_FORM);
    }
  }, [initialData, show]);

  const handleChange = (e) =>
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = () => {
    onSubmit({
      carrier_id:      Number(form.carrier_id),
      tracking_number: form.tracking_number,
      price:           parseInt(form.price, 10),
    });
  };

  const isValid = form.carrier_id && form.tracking_number && form.price;
  const isEdit  = !!initialData;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? "Modifier le transport" : "Ajouter un transport"}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Transporteur <span className="text-danger">*</span></Form.Label>
          {carriersLoading ? (
            <div className="text-center py-2"><Spinner animation="border" size="sm" /></div>
          ) : (
            <Form.Select name="carrier_id" value={form.carrier_id} onChange={handleChange}>
              <option value="">Sélectionner</option>
              {carriers.map(c => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </Form.Select>
          )}
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Numéro de suivi <span className="text-danger">*</span></Form.Label>
          <Form.Control
            name="tracking_number"
            value={form.tracking_number}
            onChange={handleChange}
            placeholder="Ex: 8J02163160386"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Prix (€) <span className="text-danger">*</span></Form.Label>
          <Form.Control
            type="number"
            name="price"
            value={form.price}
            onChange={handleChange}
            placeholder="Ex: 35"
            min="0"
            step="1"
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Annuler</Button>
        <Button variant="primary" onClick={handleSubmit} disabled={isPending || !isValid}>
          {isPending ? <Spinner size="sm" /> : isEdit ? "Modifier" : "Ajouter"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TransportModal;